module.exports = __webpack_public_path__ + "img/new_spotd2.d276f656.gif";